import React from 'react';
import { components } from 'react-select';
import '../dropdown.scss';
import ToolTip from 'src/ui/library/ToolTip';
import { formatMultiPartLabel } from 'src/helpers';

const CustomLabel = ({ children, ...props }) => {
  const { ValueContainer, Placeholder, SingleValue } = components;

  return (
    <ValueContainer {...props}>
      <ToolTip title={props.selectProps.placeholder} hideButton={true} className="dropdown-tooltip">
        <Placeholder {...props} isFocused={props.isFocused}>
          <div className="dropdown-placeholder">{props.selectProps.placeholder}</div>
          {props.selectProps.required && <div className="dropdown-required">*</div>}
        </Placeholder>
        {React.Children.map(children, child => {
          if (!child) return child;
          switch (child.type) {
            case Placeholder:
              return null;
            case SingleValue:
              // If we have a label with pipe delimitter, then format like so "{1} ({2} | {3} | {n})"
              const labelText = formatMultiPartLabel(child.props.data.label);
              return (
                <SingleValue {...props}>
                  <div title={labelText}>{labelText}</div>
                </SingleValue>
              );
            default:
              return child;
          }
        })}
      </ToolTip>
    </ValueContainer>
  );
};

export default CustomLabel;
